// react components
import React from 'react'
import axios from 'axios'

// data
import {
    contentTypeModelTypeSite,
    reduxFormHelpersStateSite,
} from 'data'

// main
export function getFormMetaSite({
    contentType,
    formState,
    helpers,
    noFullRender,
    prefixImage,
    prefixLink,
    setFormState,
    setGetMetaIsLoading,
    setHelpers,
    urltoParse,
}: {
    contentType: contentTypeModelTypeSite
    formState: any
    helpers: reduxFormHelpersStateSite
    noFullRender?: boolean
    prefixImage: string
    prefixLink?: string
    setFormState: React.Dispatch<any>
    setGetMetaIsLoading: React.Dispatch<boolean>
    setHelpers: React.Dispatch<reduxFormHelpersStateSite>
    urltoParse: string
}) {

    setGetMetaIsLoading(true)

    let urltoParse1 = encodeURIComponent(urltoParse.split('?')[0]) // Split url
    const urltoParse2 = urltoParse1.indexOf('http')
    if (urltoParse2 === -1) {
        urltoParse1 = `http://${urltoParse1}`
    }
    let getUrl = ''
    if (noFullRender) {
        getUrl = `https://opengraph.io/api/1.1/site/${urltoParse1}?app_id=5bb9403dc6006e1b00c78cda&accept_lang=auto&cache_ok=false`
    } else {
        getUrl = `https://opengraph.io/api/1.1/site/${urltoParse1}?app_id=5bb9403dc6006e1b00c78cda&full_render=true&accept_lang=auto&cache_ok=false`
    }
    axios({
        method: 'get',
        url: getUrl,
    })
        .then((response) => { // Response form opengraph.oi
            if (process.env.NODE_ENV === 'development') console.log(response)
            if (!noFullRender && response.data?.openGraph?.error) {
                getFormMetaSite({
                    contentType,
                    formState,
                    helpers,
                    noFullRender: true,
                    prefixImage,
                    prefixLink,
                    setFormState,
                    setGetMetaIsLoading,
                    setHelpers,
                    urltoParse,
                })
                return
            }
            let imageFile = ''
            if (response.data && response.data.hybridGraph && response.data.hybridGraph.image) {
                imageFile = response.data.hybridGraph.image
            } else if (response.data && response.data.htmlInferred && response.data.htmlInferred.images[0]) {
                imageFile = response.data.htmlInferred.images[0]
            }
            if (response.data && response.data.hybridGraph) { // set state from response data
                const toReturn = {
                    ...formState,
                    data: {
                        ...formState.data,
                        errors: {
                            ...formState.data.errors,
                            [`${prefixImage}image`]: '',
                            description: '',
                            meta_image_url: '',
                            name: '',
                        },
                        fields: {
                            ...formState.data.fields,
                            [`${prefixImage}image`]: imageFile,
                            get_image_lq: imageFile,
                            get_image_mq: imageFile,
                            get_image_hq: imageFile,
                            description: response.data.hybridGraph.description,
                            [`${prefixLink}link_url`]: urltoParse,
                            meta_image_url: imageFile,
                            name: response.data.hybridGraph.title,
                        },
                    }
                }
                setFormState(toReturn)
                setHelpers({
                    ...helpers,
                    buttonDisabled: false,
                    init: true,
                    mainError: '',
                })
            }
            setGetMetaIsLoading(false)
        })
        .catch((error) => {
            setFormState({
                ...formState,
                data: {
                    ...formState.data,
                    errors: {
                        ...formState.data.errors,
                        link_url: error.response?.statusText || 'Error',
                    },
                    fields: {
                        ...formState.data.fields,
                        link_url: urltoParse,
                    },
                },
            })
            setGetMetaIsLoading(false)
            if (process.env.NODE_ENV === 'development') console.log(error)
            if (process.env.NODE_ENV === 'development') console.log(error.response)
        })
}
